import React, { useEffect } from 'react';
import GameFeedbackSidebar from '../GameFeedbackSidebar/GameFeedbackSidebar'
import { Outlet, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const GameFeedbackOutlet = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        try {
            ReactGA.send({ hitType: 'pageview', page: pathname, title: 'Game Feedback' });
        } catch { }
    }, [pathname]);

    return (
        <div className="flex flex-col lg:flex-row min-h-screen bg-gray-50">
            <GameFeedbackSidebar />
            <div className="flex-1 w-full max-w-7xl mx-auto p-4 lg:p-8">
                <Outlet />
            </div>
        </div>
    )
}

export default GameFeedbackOutlet